import { create } from "zustand";
import axios from "axios";
import axiosInstance from "../../Components/axiosInstance/AxiosInstance";

const CustomersStore = create((set) => ({
  data: [],
  loading: false,
  error: null,

  fetchData: async () => {
    set({ loading: true, error: null });
    try {
      const { data } = await axiosInstance.get("/api/customers"); // Replace with your API
      console.log(data);
      set({ data: data.data, loading: false });
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },

  updateItem: async (id, updatedFields) => {
    try {
      const response = await axiosInstance.put(
        `/api/customers/${id}`,
        updatedFields
      ); // Replace with your API
      set((state) => ({
        data: state.data.map((item) =>
          item.id === id ? { ...item, ...response.data } : item
        ),
      }));
    } catch (error) {
      set({ error: error.message });
    }
  },
  // Search customers from the database
  searchCustomers: async (query) => {
    set({ loading: true, error: null });
    try {
      const { data } = await axiosInstance.get(
        `/api/customers/search?search=${query}`
      );
      set({ data: data.data, loading: false });
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },
}));

export { CustomersStore };
